import { EntityLayout } from '@backstage/plugin-catalog';
import { UserCopilotComplianceCard } from '@internal/backstage-backstage-plugin-guardrail-compliance';
import { Grid } from '@material-ui/core';
import React from 'react';

import { UserProfileCard } from '../cards/UserProfileCard';
import { CustomDomainEntityLayout } from '../../../pages/EntityLayout/CustomDomainEntityLayout';
import GeneratePatPage from '../../../pages/Pat';
import { useAppSelector } from '../../../hooks/reduxhooks';

const UserPageContent = ({ entityWarningContent }: { entityWarningContent: JSX.Element }) => {
  const loggedInUser = useAppSelector(state => state.auth.email)?.replace('@','_');
  const urlUser=window.location.pathname.split('/')[4];

  const shouldShowPatPage = loggedInUser && urlUser && loggedInUser.toLowerCase() === urlUser.toLowerCase();

  return (
    <CustomDomainEntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          {entityWarningContent}
          <Grid item xs={12}>
            <UserProfileCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/copilot-compliance" title="GitHub Copilot">
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <UserCopilotComplianceCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
      {shouldShowPatPage && (
      <EntityLayout.Route path="/generate-pat" title="Personal Access Token">
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <GeneratePatPage />
          </Grid>
        </Grid>
        </EntityLayout.Route>
      )}
    </CustomDomainEntityLayout>
  );
};

export const userPage = (entityWarningContent: JSX.Element) => (
  <UserPageContent entityWarningContent={entityWarningContent} />
);
